import type { ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { Spinner } from '@/components/ui'
import { appRoutes } from '@/constants'
import { useAuth } from '@/providers/auth-provider'
import type { Role } from '@/features/auth/types'

export interface RoleRouteProps {
  roles: Role[]
  children?: ReactNode
}

export function RoleRoute({ roles, children }: RoleRouteProps) {
  const { isAuthenticated, isLoading, role, redirectPath } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Spinner size="lg" label="Checking your session..." />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={appRoutes.auth.login} replace />
  }

  if (!role || !roles.includes(role)) {
    return <Navigate to={redirectPath} replace />
  }

  return children ?? <Outlet />
}
